export const bookingPageRegExp = /^\/(ar|en)\/movies\/[0-9a-zA-Z\-\_]+\/booking$/;
export const checkoutPageRegExp = /^\/(ar|en)\/bookings\/[0-9a-zA-Z\-\_]+\/checkout$/;
export const yourTicketPageRegExp =
  /^\/(ar|en)\/bookings\/[0-9a-zA-Z\-\_]+\/checkout\/your-ticket$/;
export const onlyNumbersRegExp = /^[0-9١-٩]+$/;

export const moviePageRegExp = /^\/(ar|en)\/movies\/[0-9a-zA-Z\-\_]+\?/;
export const onlyEnglishLettersAndSpaces = /^[A-Za-z\s]+$/;
export const preventEmptyString = /^(?!\s*$).+/;
